import type {ThunkAction} from 'src/reducers';
import type {DisplayConfig} from 'src/types/display-config';
import {thunkify as flow} from 'src/utils/thunks';
import {key, cached, fetching} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api-v2';


export const RECEIVE_CONFIG = 'configurations/display';

export type Action = ReceiveDisplayConfigAction;

export type ReceiveDisplayConfigAction = {
  type: 'configurations/display';
  payload: DisplayConfig;
};

export const receiveConfig = (
  payload: DisplayConfig,
): ReceiveDisplayConfigAction => ({
  type: RECEIVE_CONFIG,
  payload,
});

export const getDisplayConfig: () => ThunkAction<void> = flow(
  key(() => 'displayConfig'),
  // @ts-expect-error - TS7006 - Parameter 'json' implicitly has an 'any' type.
  cached((json) => receiveConfig(json), {ttl: 6 * 60 * 60 * 1000}),
  fetching(),
)(() => reduxApi.get('configurations/display'));
